export const ArchivedStatusIcon: React.FC = ({}) => {
    return(
    <svg xmlns="http://www.w3.org/2000/svg"  width="18" height="19" viewBox="0 0 18 18.007">
      <path id="Caminho_270" data-name="Caminho 270" d="M17.543,2.219,16.158.537A1.508,1.508,0,0,0,15-.01H3A1.5,1.5,0,0,0,1.842.537L.457,2.219A1.978,1.978,0,0,0,0,3.493V16a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V3.5a2,2,0,0,0-.457-1.274ZM9,15.186l-5.5-5.5h3.5V5.57h4V9.689h3.5l-5.5,5.5ZM2.125,2l.817-1h12l.935,1Z" transform="translate(0 0.01)" fill="#114d88" opacity="0.2"/>
    </svg>
  )
}